import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=aa2c3a44&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=ts"
export * from "./EventsList.vue?vue&type=script&lang=ts"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=aa2c3a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2c3a44",
  null
  
)

export default component.exports